import { PositionedSpinner } from "@flightpath/coreui/dist/ui/PositionedSpinner";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { UnassignedPlacesModel } from "./AddPlaces_model";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { PlacesGrid } from "../../../../../../../../core/grids/builder/directorBuilder/grids/PlacesGrid/PlacesGridView_view";

export const AddPlacesGrid: React.FC<{
  placeGroupId: number;
  onAssignSuccess?: (selectedItems: number[]) => void;
}> = observer(({ placeGroupId, onAssignSuccess }) => {
  const organisationId = useCurrentOrganisationId();
  const [model] = useState(() => new UnassignedPlacesModel(organisationId, placeGroupId));

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  }, [model]);

  if (model.isLoading) return <PositionedSpinner />;
  return (
    <div className="d-flex flex-column h-100">
      <div className="d-flex flex-column unassigned-places-grid h-100">
        <div className="insight-tab-content__space-filler h-100">
          <PlacesGrid
            gridToolbarType="link-modal"
            onAssignSuccess={model.assignPlaces}
            data={model.places}
            isLoading={model.isLoading}
            columnDefs={model.placesColDefs}
            // refreshDataHandler={undefined}
            onFieldUpdate={model.loadPlaces}
            placeGroupId={model.placeGroupId}
          />
        </div>
      </div>
    </div>
  );
});
